import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress,  Box, Typography, DialogContentText,  Button  } from '@mui/material';
import axios from 'axios';
import Cookies from 'js-cookie'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export default function CreateCouponDialog({ open, handleClose,couponToDelete }) {
   
    const [showSpinner, setShowSpinner] = useState(false);

    const MyAxios = axios.create({
        headers: {
            Authorization: "Bearer " + Cookies.get('token'),
        }
    })





    const onDeleteLocal = () => {

        setShowSpinner(true);
       // let Tmp = {deleteId: couponToDelete.deleteId,coupon_code: couponToDelete.coupon_code};
console.log(couponToDelete);
        MyAxios.post(process.env.REACT_APP_API + '/coupons/deletelocal/',couponToDelete)              
        .then((res) => {       
               // console.log(res)
                setShowSpinner(false);
                if(res.status === 200)    
                {
                    alert("Sauvegarde complété")
                    handleClose();
                }                   
                else      
                    alert("Erreur sauvegarde") 
                
            })
            .catch((error) => {
                console.log(error)
                alert("Erreur sauvegarde")
            });


        
    };

    const onDeleteWoo = () => {

        setShowSpinner(true);
     

        MyAxios.post(process.env.REACT_APP_API + '/woo/deleteCoupon/',couponToDelete)              
        .then((res) => {       
                console.log(res)
                setShowSpinner(false);
                if(res.status === 200)    
                {
                    alert("Sauvegarde complété")
                    handleClose();
                }                   
                else      
                    alert("Erreur sauvegarde") 
                
            })
            .catch((error) => {
                console.log(error)
                alert("Erreur sauvegarde")
            });


        
    };

    return (
         <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" sx={{ display: 'flex', alignItems: 'center' }}>
                <WarningAmberIcon sx={{ color: 'orange', marginRight: '8px' }} />
                <Typography variant="h6">
                    Confirmer la suppression du coupon
                </Typography>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" sx={{ marginBottom: 2 }}>
                    Voulez-vous vraiment supprimer ce coupon ? Vous pouvez choisir de le supprimer uniquement de ce trimestre ou de le supprimer de ce trimestre <strong>et</strong> également de WooCommerce.
                </DialogContentText>
            </DialogContent>
            {showSpinner ?
                <Box sx={{ padding: '16px' }} 
                    
                        display="flex"
                        justifyContent="center"
                        alignItems="center">                                
                
                    Communication avec la BD...
                        <CircularProgress />
                
                </Box>
            : null}

            <DialogActions sx={{ padding: '16px' }}>
                
                <Button
                    onClick={onDeleteLocal}
                    color="warning"
                    startIcon={<DeleteIcon />}
                    variant="containedFifth"
                    sx={{ marginRight: 1 }}
                >
                    Supprimer du trimestre
                </Button>
                <Button
                    onClick={onDeleteWoo}
                    color="error"
                    startIcon={<DeleteIcon />}
                    variant="containedFifth"
                >
                    Supprimer du trimestre et de WooCommerce
                </Button>
            </DialogActions>

            <Box sx={{ padding: '16px' }}>
                <Button
                    onClick={handleClose}
                    color="primary"
                    variant="containedFifth"
                    fullWidth
                    sx={{
                        backgroundColor: '#1976d2', // Bleu
                        '&:hover': { backgroundColor: '#115293' }, // Bleu plus foncé au hover
                    }}
                >
                    Annuler
                </Button>
            </Box>
        </Dialog>
    );
}
